import { render, staticRenderFns } from "./EmergenciaActivaPage.vue?vue&type=template&id=963c31f6&scoped=true&"
import script from "./EmergenciaActivaPage.vue?vue&type=script&lang=js&"
export * from "./EmergenciaActivaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963c31f6",
  null
  
)

export default component.exports